<script setup>
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const i18n = useI18n();
const route = useRoute();

watch(
  route,
  () => {
    const key = route.meta?.title?.toString() || 'title.default';
    document.title = i18n.t('title.prefix') + i18n.t(key);
  },
  { immediate: true }
);
</script>

<template>
  <router-view />
</template>
